import { createFileRoute } from "@tanstack/react-router";
import { PartnerPage } from "../../../features/partner";

export const Route = createFileRoute("/$lang/_layout/become-a-partner")({
  component: PartnerPage,
});
